import { PlainDateString } from '@sdk/types';

import { QueryKey } from '@web/common/types/QueryKey';

export const getUserIdByDateQueryKey = (date: PlainDateString) =>
  [QueryKey.USER_ID_BY_DATE, date] as const;
